module.exports = __webpack_public_path__ + "static/media/20-FILES.fbc9af53.jpg";